var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c47b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073da4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e53b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d32e28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f73744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec212f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5420841.76295624c.01620651-.42136909.36974167-.76295624.79230071-.76295624h3.42646848c.42136909 0 .77604843.3403972.79230071.76295624l.13178724 3.42646848c.01620651.42136909-.22634673.98212013-.54928247 1.25892219l-1.21487332 1.04131999c-.48223649.41334552-1.26664225.41116335-1.7463328 0l-1.21487332-1.04131999c-.31956684-.27391444-.56553475-.83636315-.54928248-1.25892219z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5420841.76295624c.01620651-.42136909.36974167-.76295624.79230071-.76295624h3.42646848c.42136909 0 .77604843.3403972.79230071.76295624l.13178724 3.42646848c.01620651.42136909-.22634673.98212013-.54928247 1.25892219l-1.21487332 1.04131999c-.48223649.41334552-1.26664225.41116335-1.7463328 0l-1.21487332-1.04131999c-.31956684-.27391444-.56553475-.83636315-.54928248-1.25892219z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#a)",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(1.904762 1.52381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.09628957 0h3.42646848c.83112076 0 1.52166965.66428312 1.55364255 1.49557862l.13178726 3.42646847c.02519273.6550112-.31604872 1.43919904-.81478329 1.8666858l-1.21487331 1.04131999c-.76689648.65733981-1.9723311.65630042-2.7380149 0l-1.21487331-1.04131999c-.49657728-.42563767-.83996001-1.21209099-.81478328-1.8666858l.13178725-3.42646847c.03194536-.83057949.72180496-1.49557862 1.55364255-1.49557862z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5420841.76295624c.01620651-.42136909.36974167-.76295624.79230071-.76295624h3.42646848c.42136909 0 .77604843.3403972.79230071.76295624l.13178724 3.42646848c.01620651.42136909-.22634673.98212013-.54928247 1.25892219l-1.21487332 1.04131999c-.48223649.41334552-1.26664225.41116335-1.7463328 0l-1.21487332-1.04131999c-.31956684-.27391444-.56553475-.83636315-.54928248-1.25892219z",
    fill: "url(#e)",
    transform: "translate(.761905 .761905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.66666667 3.99637277c0-.10319383-.08967808-.18684896-.18871961-.18684896h-.76541792c-.10422697 0-.18871962-.08153716-.18871962-.19226074v-.37738328c0-.10618268.08967808-.19226074.18871962-.19226074h.76541792c.10422696 0 .18871961-.08153716.18871961-.19226074v-.37738329c0-.10618267-.08153716-.19226073-.19226074-.19226073h-.37738329c-.10618267 0-.19226074-.08153716-.19226074-.19226074v-.37738329c0-.10618267.08153716-.19226074.19226074-.19226074h.37738329c.10618267 0 .19226074-.08153715.19226074-.19226074v-.37738328c0-.10618267.08153715-.19226074.19226074-.19226074h.37738328c.10618267 0 .19226074.08153716.19226074.19226074v.37738328c0 .10618268.08153716.19226074.19226074.19226074h.37738328c.10618268 0 .19226074.08153716.19226074.19226074v.37738329c0 .10618267-.08153716.19226074-.19226074.19226074h-.37738328c-.10618268 0-.19226074.08153715-.19226074.19226073v.37738329c0 .10618267.08967808.19226074.18871961.19226074h.76541792c.10422696 0 .18871961.08153716.18871961.19226074v.37738328c0 .10618267-.08967808.19226074-.18871961.19226074h-.76541792c-.10422696 0-.18871961.08192662-.18871961.18684896v1.1501116c0 .10319383-.08153716.18684896-.19226074.18684896h-.37738328c-.10618268 0-.19226074-.08192662-.19226074-.18684896z",
    fill: "url(#a)",
    mask: "url(#g)",
    transform: "translate(.761905 .761905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.35988492 5.38597131c-.92629548.14594158-1.59798016.57886029-1.59798016 1.09021917 0 .63118255 1.02334914 1.14285714 2.28571429 1.14285714 1.26236514 0 2.28571428-.51167459 2.28571428-1.14285714 0-.51135888-.67168467-.94427759-1.59798016-1.09021917-.12264474-.25644725-.38450243-.43359036-.68773412-.43359036s-.56508938.17714311-.68773413.43359036z",
    fill: "#1251a1",
    mask: "url(#h)",
    transform: "translate(.761905 .761905)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.ad17035e60e25eca88ce9612d4cff98c.svg";
export { ForwardRef as ReactComponent };